import { getStakeNamesTemplateUrl } from '../../../bin/constants';
import { getStakesNamesTemplates } from '../../configs/stakesNamesTemplates';
import { ConfigsRequests, createFetchRequest, fetchConfigs, FetchRequestKey } from '../../init-client-configs';
import { SupportedLang } from '../../lang';
import { getUniversalUrl } from '../get-universal-url';

export const fetchStakeNamesTemplateByChangeLang = async (lang?: SupportedLang) => {
  const configsRequests: ConfigsRequests = [];
  const stakesNames = createFetchRequest(
    FetchRequestKey.NAMES,
    getUniversalUrl(getStakeNamesTemplateUrl(lang)),
    0,
    getStakesNamesTemplates,
    lang,
  );
  stakesNames && configsRequests.push(stakesNames);

  return await fetchConfigs(configsRequests);
};
